import SEOItemWrapper from './SEOItemWrapper';

export default function SEOTextArea({ id, label, addonLabel, seo, value, ...textareaProps }) {
  return (
    <SEOItemWrapper id={id} label={label} addonLabel={addonLabel} seo={seo} value={value}>
      <div className="input-group">
        <textarea className="form-control" id={id} aria-describedby={`${id}-addon`} value={value} {...textareaProps} />
      </div>
    </SEOItemWrapper>
  );
}
